var map = {
	"./ds.svg": "6be6",
	"./es.svg": "4799",
	"./ls.svg": "6efc",
	"./ms.svg": "39a4",
	"./ns.svg": "6384",
	"./oda.svg": "9f60",
	"./poks.svg": "e606",
	"./ps.svg": "8780",
	"./rs.svg": "bda7",
	"./spf.svg": "2a6f",
	"./ss.svg": "813f",
	"./sss.svg": "6e5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7040";